<!--  -->
<template>
  <div>
    <section class="category-area">
        <div class="container">
            <div class="row">
              <div class="section-heading">
                  <h2 class="section__title"><span>直播中心</span></h2>
                  <span>经典课程推荐，帮助您就业，考完即拿证书</span>
              </div><!-- end section-heading -->
            </div><!-- end row -->
            <div class="container" v-if="lives && lives.length > 0">
              <div class="row category-wrapper" >
                <div :class="index==0?'col-lg-12':'col-lg-4'"  v-for="(live,index) in lives" :key="index" >
                    <div class="category-item" v-if="index == 0">
                        <div class="course-tooltip">
                          <span class="cat__title"><router-link :to="`/mylive/${live._id}`">{{ live.title }}</router-link></span>
                        </div>
                        <div class="category-content">
                          <div class="teacher">
                            <span :style="`padding-left:63px;background-image:url(/static/img/a1.png);background-repeat: no-repeat;background-size: 50px auto;background-position: left center;`" class="name">{{live.teacher}}</span>
                            <span class="tip">大学教授</span>
                            <span class="tooltip-label">{{ dateFormat(new Date(live.time), "yyyy-MM-dd hh:mm") }}</span>
                          </div>
                          <div class="info">
                            零基础学Python数据分析【华为开发者学堂证书】小白30分钟入门计算机等级测评-6月22日小白30分钟入门计算机等级测评-6月22日
                          </div>
                          <div class="cat__meta_right">
                            <span class="datetime">直播时间 {{ dateFormat(new Date(live.time), "MM月dd日 hh:mm") }}</span>
                            <span class="more" @click="$router.push(`/liveview`)">MORE</span>
                          </div>
                        </div>
                        <div class="on-vodio" @click="$router.push(`/mylive/${live._id}`)">
                          <img :src="live.picsrc ? `${global.remoteIp}/uploads/${live.picsrc}` : '/static/images/mor.jpg'" alt="">
                        </div> 
                    </div>
                    <div class="category-item" v-else>
                        <!-- <img :src="live.picsrc ? `${global.remoteIp}/uploads/${live.picsrc}` : '/static/images/mor.jpg'" alt=""> -->
                        <!-- <div class="course-tooltip">
                          <span class="tooltip-label">{{ dateFormat(new Date(live.time), "yyyy-MM-dd hh:mm") }}</span>
                        </div> -->
                        <!-- <div class="category-content" >
                            <span class="cat__meta_right"> <router-link :to="`/mylive/${live._id}`" class="read-more" style="live.state=='1'?'color: #62C485;':''">{{ live.state == '1' ? '已开播' : '未开播' }}</router-link></span>
                        </div> -->
                        <div class="category-content green" v-if="index==1">
                              <span class="cat__meta_right"> <router-link :to="`/mylive/${live._id}`" class="read-more" style="background-color: #63C4AA;border-radius: 14px;">直播中</router-link></span>
                              <div class="heng">
                                <span class="one"></span>
                                <span class="two"></span>
                                <span class="three"></span>
                              </div>
                        </div>
                        <div class="category-content" v-if="index == 2">
                          <span class="cat__meta_right"> <router-link :to="`/mylive/${live._id}`" class="read-more">{{ dateFormat(new Date(live.time), "MM月dd日 hh:mm开始") }}</router-link></span>
                        </div>
                        <div class="category-content free" v-if="index == 3">
                            <span class="cat__meta_right"> <router-link :to="`/mylive/${live._id}`" style="color:#666666;background-color: #F5F5F5;border-radius: 14px;" class="read-more">{{ dateFormat(new Date(live.time), "MM月dd日 hh:mm即将开始") }}</router-link></span>
                          </div>
                        <div class="info">
                          零基础学Python数据分析【华为开发者学堂证书】小白30分钟入门计算机等级测评-6月22日小白30分钟入门计算机等级测评-6月22日
                        </div>
                        <div class="teacher">
                          <span :style="`padding-left:73px;background-image:url(/static/img/a1.png);background-repeat: no-repeat;background-size: 60px auto;background-position: 5px center;`" class="name">{{ live.teacher }}（副教授）</span>
                          <span @click="$router.push(`/mylive/${live._id}`)" class="tip">100{{ live.__v }}</span>
                        </div>
                    </div>
                </div>
              </div>
              <!-- <div class="container">
                  <div class="align-items-center">
                      <router-link class="theme-btn" to="/liveview">所有直播</router-link>
                  </div>
              </div> -->
            </div>
            <el-card  v-else  class="box-card">
                <el-empty description="暂无相关直播"></el-empty>
            </el-card>
        </div><!-- end container -->
    </section><!-- end category-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      lives: [],
      global,
    };
  },

  components: {},

  computed: {},

  mounted() {

    this.$axios
      .get("/api/livings?page=1&limit=6&sort=-createdAt")
      .then((res) => {
        if (res.data) {
          this.lives = res.data.data;
          this.intTotal = res.data.total;
        }
      });
  },

  methods: {
     dateFormat(date, format) {
      var o = {
        "M+": date.getMonth() + 1, //month
        "d+": date.getDate(), //day
        "h+": date.getHours(), //hour 24
        "H+": date.getHours(), //hour 24
        "m+": date.getMinutes(), //minute
        "s+": date.getSeconds(), //second
        "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
        S: date.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }

      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return format;
    },
  },
};
</script>
<style scoped>

a:not([href]):not([tabindex]) {
    color: initial !important;
}

.category-item{
/* width: 294px;
height: 212px; */
border-radius: 5px;
border:none;
height: auto;
}
.category-item img{
width: 100%;
height: 212px;
border-radius: 5px;
}
.course-tooltip {
    /* height: 25px; */
       position: absolute;
        top: 197px;
    right: 7px;
    border-radius: 10px 0px 0px 0px;
    height: 25px;
    padding: 2px;
    
}
.tooltip-label{
  font-size: 12px;
    color: #FFFFFF;
}
.cat__title {
  width: 200  px;
height: 14px;
font-size: 14px;
font-weight: 600;
color: #313F57;
text-align: left;
}
.cat__title a{
  color: #313F57;
}

.category-content{
  margin-top: 17px;
}
.cat__meta_right{
      float: right;
      line-height:23px;
      width: auto;
}
.cat__meta_right a{
  color: #313F57;
      width: 41px;
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F68A03;
   
}
.category-item{
      width: 300px;
      padding: 10px;
}
.col-lg-3{
  padding-left: 10px;
  padding-right:10px;
}
.col-lg-12{
  width: 1200px;
  margin-bottom: 44px;
}
.col-lg-12 .category-item{
  position: relative;
  width: 1200px;
  height: 417px;
}
.col-lg-12 .category-item .on-vodio{
  position: absolute;
  top: 0;
  right: 0;
  width: 679px;
height: 417px;
}
.col-lg-12 .category-item .on-vodio img{
  width: 679px;
height: 417px;
border-radius: 0;
}
.col-lg-12 .category-item .on-vodio::before{
   cursor: pointer;
  z-index: 1;
  position: absolute;
  content: '';
   top: 0;
  right: 0;
  width: 679px;
height: 417px;
background: #4462CF;
opacity: 0.63;
background-image: url(/static/img/bofang.png);
background-repeat: no-repeat;
background-size: 44px 44px;
background-position: center center;
}
.col-lg-12 .category-item .course-tooltip{
  position: absolute;
   top: 0;
  left: 0;
  width: 236px;
height: 62px;
background-image: url(/static/img/biaotiqan.png);
background-repeat: no-repeat;
background-size: 236px auto;
background-position: center center;
text-align: center;
}
.col-lg-12 .category-item .course-tooltip a{
  display: inline-block;
  width: 148px;
  height: 48px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 48px;
  text-align: center;
  -webkit-background-clip: text;
  word-break: break-all;
  -webkit-box-orient: vertical;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.col-lg-12 .category-item .category-content{
  z-index: 2;
  position: absolute;
  padding: 38px 41px 45px 36px;
  left: 0;
  bottom: 0;
  width: 576px;
height: 313px;
background: #FFFFFF;
box-shadow: 0px 0px 24px 0px rgba(200,200,200,0.38);
}
.col-lg-12 .category-item .category-content .teacher{
  width: 100%;
  height: 50px;
}
.col-lg-12 .category-item .category-content .teacher span{
  float: left;
padding: 0 13px;
height: 50px;
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #4A576A;
line-height: 50px;
}
.col-lg-12 .category-item .category-content .teacher .tooltip-label{
  float: right;
  padding: 0;
  width: 200px;
  height: 50px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 48px;
  text-align: right;
}
.col-lg-12 .category-item .category-content .teacher span.tip{
  margin-top: 14.5px;
  padding: 0;
  width: 69px;
height: 21px;
background: #00D57A;
border-radius: 3px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
line-height: 21px;
color: #FFFFFF;
text-align: center;
}
.col-lg-12 .category-item .category-content .info{
  margin-top: 30px;
  width: 481px;
height: 70px;
font-size: 20px;
font-family: PingFang SC;
font-weight: bold;
color: #4A576A;
line-height: 40px;
overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.col-lg-12 .category-item .category-content .cat__meta_right{
  margin-top: 71px;
  width: 100%;
}
.col-lg-12 .category-item .category-content .cat__meta_right .datetime{
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #4A576A;
line-height: 16px;
}
.col-lg-12 .category-item .category-content .cat__meta_right .more{
  cursor: pointer;
  float: right;
  padding-right: 41px;
height: 18px;
font-size: 18px;
font-family: PingFang SC;
font-weight: 500;
color: #F55C57;
line-height: 18px;
background-image: url(/static/img/youla.png);
background-repeat: no-repeat;
background-size: 35px auto;
background-position: right center;
}
.col-lg-4 .category-item{
  position: relative;
  width: 392px;
height: 169px;
background: #FFFFFF;
box-shadow: 0px 0px 10px 0px rgba(200,200,200,0.2);
border-radius: 10px;
}
.col-lg-4 .category-item .category-content{
  padding: 0 7px;
margin-top: 11px;
}
.col-lg-4 .category-item .category-content .cat__meta_right{
  float: none;
  height: 27px;
  background: #FCB04E;
  border-radius: 14px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FCFCFC;
  line-height: 27px;
  text-align: left;
}
.col-lg-4 .category-item .category-content .cat__meta_right a{
  position: relative;
  color: #FCFCFC;
  padding-left:23px;
  padding-right: 13px;
}
.col-lg-4 .category-item .category-content .cat__meta_right a::before{
  position: absolute;
  top: 7.5px;
    left: 10px;
  content: '';
  width: 6px;
height: 6px;
background: #FFFFFF;
border-radius: 50%;
}
.col-lg-4 .category-item .green .cat__meta_right a{
    padding-right: 46px;
}
.col-lg-4 .category-item .green .heng{
  position: absolute;
  top:6px;
  left:90px;
  width: 14px;
  height: 13px;
  display: flex;
  align-items:end ;
}
.col-lg-4 .category-item .green .heng span{
    float: left;
}
.col-lg-4 .category-item .green .heng span.one{
  width: 2px;
height: 8px;
background: #FFFFFF;
border-radius: 1px;
}
.col-lg-4 .category-item .green .heng span.two{
  width: 2px;
  height: 13px;
  background: #FFFFFF;
border-radius: 1px;
  margin-left: 4px;
}
.col-lg-4 .category-item .green .heng span.three{
  width: 2px;
  height: 11px;
  background: #FFFFFF;
border-radius: 1px;
  margin-left: 4px;
}
.col-lg-4 .category-item .free .cat__meta_right a::before{
    background: #cccccc;
}
.col-lg-4 .category-item .info{
  position: absolute;
  top:73px;
  left: 86px;
  width: 273px;
  height: 42px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.col-lg-4 .category-item .teacher{
  position: relative;
  overflow: hidden;
}
.col-lg-4 .category-item .teacher .name{
  float: left;
  margin-top: 30px;
  height: 80px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #999999;
line-height: 140px;
}
.col-lg-4 .category-item .teacher .tip{
  cursor: pointer;
 position: absolute;
 padding-left: 20px;
 right: 0;
 bottom: 2px;
  height: 15px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #313F57;
  line-height: 15px;
  background-image: url(/static/img/renshush.png);
background-repeat: no-repeat;
background-size: 15px auto;
background-position: left center;
}
</style>
